import { FeatureToggleClientService } from 'feature-toggle-client';
const AllowAiAgentAccessDefaultScreens = 'allow-ai-agent-access-default-screens';
const AllowCreatingAiAgentInMfe = 'allow-creating-ai-agent-in-mfe';
export class AiAgentFeature {
    static async allowAiAgentAccessDefaultScreensEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(AllowAiAgentAccessDefaultScreens, false);
    }
    static async allowCreatingAiAgentInMfeEnabled() {
        return await FeatureToggleClientService.getInstance().isUserFeatureEnabled(AllowCreatingAiAgentInMfe, false);
    }
}
